(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-vn-product-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      if (!slides.length) return;
      hero.dataset.ready = 'true';
      const stage = hero.querySelector('[data-hero-stage]') || hero.querySelector('.vn-product-hero__stage');
      const dots = [...hero.querySelectorAll('[data-hero-go]')];
      const pause = hero.querySelector('[data-hero-pause]');
      const previous = hero.querySelector('[data-hero-prev]');
      const next = hero.querySelector('[data-hero-next]');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = matchMedia('(max-width: 749px)');
      const cleanup = [];
      let active = 0, timer = null, paused = motion.matches, hover = false;
      let pauseClickTarget = null, gesture = null, suppressClickUntil = 0;
      const listen = (target, type, handler, options) => {
        if (!target) return;
        target.addEventListener(type, handler, options);
        cleanup.push(() => target.removeEventListener(type, handler, options));
      };
      [previous, next].forEach(button => { if (button) button.hidden = slides.length < 2; });

      function show(index, focusTarget) {
        const destination = (index + slides.length) % slides.length;
        // Never leave keyboard focus inside a slide that is becoming inert.
        if (destination !== active && slides[active].contains(document.activeElement)) {
          (focusTarget || dots[destination] || pause)?.focus({ preventScroll: true });
        }
        active = destination;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          slide.inert = i !== active;
          slide.setAttribute('aria-hidden', String(i !== active));
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === active)));
      }
      function schedule() {
        clearInterval(timer);
        timer = null;
        if (pause) {
          pause.textContent = paused ? 'Reanudar' : 'Pausar';
          pause.setAttribute('aria-label', paused ? 'Reanudar cambio automático de banners' : 'Pausar cambio automático de banners');
        }
        if (!paused && !hover && !gesture && !document.hidden && slides.length > 1) {
          timer = setInterval(() => show(active + 1), 7000);
        }
      }
      function manual(index, focusTarget) {
        paused = true;
        show(index, focusTarget);
        schedule();
      }
      dots.forEach(dot => listen(dot, 'click', () => manual(Number(dot.dataset.heroGo), dot)));
      listen(previous, 'click', () => manual(active - 1, previous));
      listen(next, 'click', () => manual(active + 1, next));
      // Pointer focus pauses before click; retain the action chosen before focus.
      listen(pause, 'pointerdown', () => { pauseClickTarget = !paused; });
      listen(pause, 'pointercancel', () => { pauseClickTarget = null; });
      listen(pause, 'click', event => {
        paused = event.detail > 0 && pauseClickTarget !== null ? pauseClickTarget : !paused;
        pauseClickTarget = null;
        schedule();
      });
      listen(hero, 'mouseenter', () => { hover = true; schedule(); });
      listen(hero, 'mouseleave', () => { hover = false; schedule(); });
      listen(hero, 'focusin', () => { paused = true; schedule(); });

      function finishGesture() {
        const pointerId = gesture?.pointerId;
        gesture = null;
        if (pointerId !== undefined && stage?.hasPointerCapture?.(pointerId)) {
          stage.releasePointerCapture(pointerId);
        }
      }
      listen(stage, 'pointerdown', event => {
        // A fresh tap must never inherit click suppression from a previous swipe.
        suppressClickUntil = 0;
        if (gesture) { finishGesture(); schedule(); return; }
        if (!mobile.matches || slides.length < 2 || event.isPrimary === false ||
            !['touch', 'pen', 'mouse'].includes(event.pointerType) ||
            (event.pointerType === 'mouse' && event.button !== 0) ||
            event.target.closest('a, button, input, select, textarea, summary, [contenteditable], [role="button"]')) return;
        gesture = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, axis: null };
        schedule();
      }, { passive: true });
      listen(stage, 'pointermove', event => {
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 12) {
          if (Math.abs(dy) >= Math.abs(dx)) {
            // Vertical gestures belong to page scrolling for their entire duration.
            finishGesture(); schedule(); return;
          }
          if (Math.abs(dx) >= Math.abs(dy) * 1.25) {
            gesture.axis = 'horizontal';
            stage.setPointerCapture?.(event.pointerId);
          }
        }
      }, { passive: true });
      listen(stage, 'pointerup', event => {
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
        const threshold = Math.max(48, Math.min(96, stage.clientWidth * 0.12));
        const swipe = mobile.matches && gesture.axis === 'horizontal' &&
          Math.abs(dx) >= threshold && Math.abs(dx) >= Math.abs(dy) * 1.25;
        finishGesture();
        if (swipe) {
          suppressClickUntil = Date.now() + 500;
          manual(active + (dx < 0 ? 1 : -1));
        } else schedule();
      }, { passive: true });
      const cancelGesture = event => {
        if (!gesture || event.pointerId !== gesture.pointerId) return;
        finishGesture(); schedule();
      };
      listen(stage, 'pointercancel', cancelGesture, { passive: true });
      listen(stage, 'lostpointercapture', event => {
        // Touch starts with implicit capture on the touched child. Ignore its
        // bubbling loss when capture transfers to the stage for a swipe.
        if (event.target === stage) cancelGesture(event);
      }, { passive: true });
      listen(stage, 'pointerleave', event => {
        if (gesture && event.pointerType === 'mouse' && !stage.hasPointerCapture?.(gesture.pointerId)) {
          finishGesture(); schedule();
        }
      }, { passive: true });
      listen(stage, 'dragstart', event => {
        if (mobile.matches && event.target.closest('.vn-product-hero__media')) event.preventDefault();
      });
      listen(stage, 'click', event => {
        if (event.detail !== 0 && Date.now() < suppressClickUntil) {
          suppressClickUntil = 0;
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);
      listen(document, 'visibilitychange', () => { finishGesture(); schedule(); });
      listen(motion, 'change', () => { if (motion.matches) paused = true; schedule(); });
      listen(mobile, 'change', () => { finishGesture(); schedule(); });
      hero._destroyHero = () => {
        finishGesture();
        clearInterval(timer);
        cleanup.forEach(remove => remove());
        delete hero.dataset.ready;
        delete hero._destroyHero;
      };
      show(0); schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-vn-product-hero]').forEach(hero => hero._destroyHero?.());
  });
})();
